import { WAREHOUSE_PRICE_MODES } from './consts';

const defaultRecord = () => ({
  name: '',
  workName: '',
  shoppingName: '',
  shortName: '',
  weight: '',
  calories: '',
  fat: '',
  carbohydrates: '',
  monosaccharide: '',
  proteins: '',
  dietaryFiber: '',
  salt: '',
  nkt: '',
  note: null,
  allert: false,
  wot: 100,
  wom: 100,
  price: '',
  pricePerUnit: '',
  pricePerKg: '',
  inventoryAmountInWeight: '',
  inventoryAmountInUnit: '',
  hermesCardIndex: '',
  glycemicIndex: '',
  allergens: [],
  unit: null,
  categories: [],
  wholesaler: null,
  products: [],
  warehousePriceMode: WAREHOUSE_PRICE_MODES.WEIGHT,
});

const defaultState = {
  __originalRecord: defaultRecord(),
  ...defaultRecord(),
  historyHidden: true,
  confirmNestedUpdatesModal: false,
};

export default defaultState;
